import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';


import {clearSelection} from 'src/components/data-table-selection';
import {AccountSortField as AccountSortFields} from 'src/openapi/admin/models/AccountSortField';
import {SortDirection, SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';

import {COLUMNS, HEADERS, SELECTION_KEY} from '../../constants';
import {useGetUserConferencesPrimaryManager} from '../../hooks/useGetUserConferencesPrimaryManager';
import {
    userConferencesStateActions,
    userConferencesStateSelector,
} from '../../slices/user-conferences-state.slice';
import {userConferencesResultSelector} from '../../slices/user-conferences.slice';

import {HeaderContentBefore} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';

type Props = {
    accountIds: number[],
    totalCount: number,
};

const PrimaryManagerHeaderController = ({accountIds, totalCount}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(userConferencesStateSelector);
    const {isLoading, loadingError} = useGetUserConferencesPrimaryManager({accountIds, totalCount});

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        dispatch(clearSelection(SELECTION_KEY));
        dispatch(userConferencesStateActions.setSortCriteria({
            direction: direction as SortDirection,
            field: AccountSortFields.PRIMARY_ACCOUNT_MANAGER,
        }));
    }, [dispatch]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === AccountSortFields.PRIMARY_ACCOUNT_MANAGER
                ? cacheKeys.sortCriteria.direction
                : null}
            filterActive={true}
            caption={HEADERS[COLUMNS.PRIMARY_ACCOUNT_MANAGER]}
            contentBefore={(isLoading || loadingError)
                ? <HeaderContentBefore isLoading={isLoading} loadingError={loadingError}/>
                : undefined}
            onSort={sort}
        />
    );
};

export const PrimaryManagerHeader = () => {
    const result = useSelector(userConferencesResultSelector);

    return result ? (
        <PrimaryManagerHeaderController
            accountIds={result.data.map(({accountId}) => accountId).filter(Boolean)}
            totalCount={result.totalCount}
        />
    ) : (
        <HeaderSkeleton columnId={COLUMNS.PRIMARY_ACCOUNT_MANAGER}/>
    );
};
